export default "__VITE_ASSET__DTnKQ7yK__"